module.exports = __webpack_public_path__ + "static/img/two-arrow-down.26fc812c.png";